module.exports = __webpack_public_path__ + "static/media/Pheasant-Ridge-By-Laws.da617b09.pdf";